import React from 'react'


const Bg = () => {
    return (
        <>
            <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 divide-x-[.5px] divide-[#272727] fixed top-0 left-0 right-0 -z-10">
                <div className="h-screen"></div>
                <div className="h-screen"></div>
                <div className="h-screen"></div>
                <div className="h-screen hidden md:block"></div>
                <div className="h-screen hidden lg:block"></div>
                <div className="h-screen hidden lg:block"></div>
            </div>

            
        </>

    )
}

export default Bg
